export default function PetroleumIcon() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.41C14.0873 17.41 17.4007 14.0924 17.4007 9.99999C17.4007 5.90755 14.0873 2.58997 10 2.58997C5.91272 2.58997 2.59932 5.90755 2.59932 9.99999C2.59932 14.0924 5.91272 17.41 10 17.41Z"
                fill="#BD732B"
            />
            <path
                d="M11.4519 5.7304V4.94H8.45643V5.7304H6.50053V6.89837H13.4995V5.7304H11.4519Z"
                fill="white"
            />
            <path
                d="M6.50053 7.71701V9.9506H8.45643V10.9315H11.4519V9.9506H13.4995V7.71701H6.50053Z"
                fill="white"
            />
            <path
                d="M12.2167 10.808V11.7219H7.69169V10.808H6.50053V15.06H13.4995V10.808H12.2167Z"
                fill="white"
            />
        </svg>
    );
}
